<template>
    <img src="/images/promo/hero-section/balance-scale.png"
     alt="Balance scale" />
</template>

<script>
export default {};
</script>
